<template>
  <div class="chat">
    <iframe :src="goUrl" frameborder="0" class="frame-container"></iframe>
  </div>
</template>

<script>
export default {
  name: "Chat",
  data() {
    return {
      goUrl: ""
    };
  },
  mounted() {
    this.goUrl = `http://recruit.ve-city.com/chat`;
  }
};
</script>

<style lang="scss" scoped>
.chat {
  width: 100%;
  height: calc(100%-60px);
  position: relative;
  overflow: none;
  border: none;
  iframe {
    width: calc(100% + 115px);
    height: calc(100vh - 115px);
    margin-left: -100px;
    border: none;
    position: relative;
  }
}
</style>
